import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from '../dialogs/dialogs.module';
import { CkEditorInsertImagePluginService } from './ck-editor-insert-image-plugin.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, FormsModule, DialogModule, TranslateModule.forChild()],
  declarations: [],
  entryComponents: [],
  providers: [CkEditorInsertImagePluginService]
})
export class CkEditorInsertImagePluginModule {
}
